import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import withAuth from '../../../HOC/withAuth';
import { useTranslation } from '../../../t';
import Empty from '../../../components/Empty';
import CustomPagination from '../../../components/Pagination';
import dayjs from 'dayjs';
import InfoBar from '../InfoBar';
import C from '../../../colors';

const IncomesIndex = inject('userStore')(observer(({ userStore }) => {
  const { t } = useTranslation();
  const [data, setData] = useState({ incomes: [], totalIncome: 0, totalPayments: 0 });
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  const fetchData = () => {
    userStore.fetchIncomes(page).then(d => {
      setData(d);
      setTotalPage(d.totalPages || 1);
    });
  };
  useEffect(() => { fetchData(); }, [page]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <InfoBar />
      <div style={{ flex: 1, overflow: 'auto', padding: '28px 36px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 24 }}>
          <h1 style={{ margin: 0, fontFamily: C.serif, fontSize: 36, fontWeight: 400, color: C.ink }}>{t('Income Management')}</h1>
          <button data-testid="income-refresh" onClick={fetchData} style={{
            display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 7,
            border: `1px solid ${C.hair2}`, background: '#fff', color: C.ink2, fontFamily: C.sans, fontSize: 13, fontWeight: 500, cursor: 'pointer',
          }}>↻ {t('Refresh Status')}</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16, marginBottom: 24 }}>
          {[{ l: t('Total Income'), v: `¥${Number(data.totalIncome || 0).toFixed(2)}`, a: true, testId: 'income-total-amount' },
            { l: t('Paid Transactions'), v: data.totalPayments || 0, testId: 'income-total-payments' }].map(k => (
            <div key={k.l} data-testid={k.testId} style={{ background: '#fff', border: `1px solid ${C.hair}`, borderRadius: 12, padding: '18px 20px' }}>
              <div style={{ fontFamily: C.mono, fontSize: 10, letterSpacing: 1.2, textTransform: 'uppercase', color: C.ink3, marginBottom: 8 }}>{k.l}</div>
              <div style={{ fontFamily: C.serif, fontSize: 28, color: k.a ? C.brand2 : C.ink }}>{k.v}</div>
            </div>
          ))}
        </div>

        {(!data.incomes || data.incomes.length === 0) ? (
          <Empty message={t('No income records')}/>
        ) : (
          <div style={{ background: '#fff', border: `1px solid ${C.hair}`, borderRadius: 14, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: C.sans }}>
              <thead>
                <tr style={{ borderBottom: `1px solid ${C.hair}`, background: C.paper2 }}>
                  {[t('Order ID'), t('Customer'), t('Price'), t('Payment Date'), t('Status')].map(h => (
                    <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: C.ink3, fontFamily: C.mono, textTransform: 'uppercase', letterSpacing: 1 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.incomes.map((r, i) => (
                  <tr key={r.id || i} data-testid={r.id ? `income-row-${r.id}` : undefined} style={{ borderBottom: i < data.incomes.length - 1 ? `1px solid ${C.hair}` : 'none' }}>
                    <td style={{ padding: '14px 16px', fontSize: 13, color: C.ink, fontFamily: C.mono }}>{r.orderId}</td>
                    <td style={{ padding: '14px 16px', fontSize: 13, color: C.ink2 }}>{r.customerName || t('Unknown User')}</td>
                    <td data-testid={r.id ? `income-price-${r.id}` : undefined} style={{ padding: '14px 16px', fontSize: 13, color: C.ink }}>¥{Number(r.price || 0).toFixed(2)}</td>
                    <td style={{ padding: '14px 16px', fontSize: 13, color: C.ink2 }}>{r.paymentDate ? dayjs(r.paymentDate).format('YYYY-MM-DD HH:mm') : '—'}</td>
                    <td style={{ padding: '14px 16px' }}>
                      <span style={{ padding: '3px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600, background: r.status === 'paid' ? C.successBg : C.warningBg, color: r.status === 'paid' ? C.successFg : C.warningFg }}>{t(r.status || 'pending')}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {totalPage > 1 && <div style={{ marginTop: 16 }}><CustomPagination count={totalPage} page={page} onChange={(_, v) => setPage(v)}/></div>}
      </div>
    </div>
  );
}));

export default withAuth(IncomesIndex);
